<p-dialog
    [(visible)]="visible"
    [header]="'service.settings.general.workgroup.label' | translate"
    styleClass="p-dialog-width-30"
>
    <div class="flex gap-large">
        <div class="flex-column gap-large flex-1 py-3 px-2">
            <app-text-input [form]="form" id="name"
                label="service.settings.general.workgroup.fields.name"
            ></app-text-input>
            <app-text-input [form]="form" id="description"
                label="service.settings.general.workgroup.fields.description"
            ></app-text-input>
            <app-check-input [form]="form" id="active"
                label="service.settings.general.workgroup.fields.active"
            ></app-check-input>
            <app-color-input [form]="form"></app-color-input>
        </div>
    </div>

    <ng-template #footer>
        <app-action-buttons (primaryClickEvent)="submit()" (secondaryClickEvent)="show(false)"></app-action-buttons>
    </ng-template>
</p-dialog>
